import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import Btn_loader from "../Btn_loader";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import ImageLoad from "../ImageLoad";
import KundliImg from "../../image/janamKundali.png";
import PageLoading from "../PageLoading";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import axios from "axios";
const renderVal = (val) => {
    if (val === null || val === undefined) return "";
    if (typeof val === 'object') {
        return val.result || val.name || JSON.stringify(val);
    }
    return val;
};

const Kundali_details = () => {

    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi, setIsToast, setToastMsg, formatPrice } = useContext(MyContext);

    const kundliTypeList = ["Introduction", "Basic Astrological Details", "Planetary Positions", "Horoscope Charts", "House Cusps And Sandhi", "Divisional Charts", "Composite Friendship Table", "Kp Planetary Details", "Kp House Cusps And Chart", "Ascendant Report", "Bhava Kundli", "Vimshottari Dasha", "Yogini Dasha", "Sadhesati Analysis", "Sadhesati Life Analysis", "Kalsarpa Dosha", "Manglik Analysis", "Planet Profiles", "Gemstone Suggestions", "Upagraha", "Jaimini Astrology", "Chara Dasha", "Shadbala", "Sudarshana Chakra", "Bhinnashtakvarga", "Yogas"];
    const KundliTypeApiList = ["introduction", "basicAstrologicalDetails", "planetaryPositions", "horoscopeCharts", "houseCuspsAndSandhi", "divisionalCharts", "compositeFriendshipTable", "kpPlanetaryDetails", "kpHouseCuspsAndChart", "ascendantReport", "bhavaKundli", "vimshottariDasha", "yoginiDasha", "sadhesatiAnalysis", "sadhesatiLifeAnalysis", "kalsarpaDosha", "manglikAnalysis", "planetProfiles", "gemstoneSuggestions", "upagraha", "jaiminiAstrology", "charaDasha", "shadbala", "sudarshanaChakra", "bhinnashtakvarga", "yogas"];

    const Location = useLocation();
    const navigate = useNavigate();
    const KundliData = Location.state;

    const [loading, setLoading] = useState(true);
    const [isstep, setIsStep] = useState(0);
    const [detailsstep, setDetailsStep] = useState(1);
    const [showlist, setShowList] = useState(false);
    const [apiloading, setApiLoading] = useState("");
    const [userdata, setUserData] = useState("");
    const [selecttype, setSelectType] = useState(0);
    const [downloadingPdf, setDownloadingPdf] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [savedKundliId, setSavedKundliId] = useState(KundliData?.id || KundliData?.Kundli_id || "");
    const [pdfLanguage, setPdfLanguage] = useState((KundliData?.wblanguage && KundliData.wblanguage.slice(0, 2) === "hi") ? "hi" : "en");

    const HomeRef = useRef(false);

    const handleDownloadPdf = async () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (!Userid || Userid === "0") {
            setToastMsg("Please login to download your Kundli PDF.");
            setIsToast(true);
            navigate("/auth/login");
            return;
        }

        const currentKundliId = savedKundliId || KundliData?.id || KundliData?.Kundli_id || "";
        if (!currentKundliId) {
            setToastMsg("Kundli profile not found. Please try again.");
            setIsToast(true);
            return;
        }

        const isPremium = secureLocalStorage.getItem("kundli_pdf_status") === "1" || secureLocalStorage.getItem("kundli_pdf_status") === 1;
        const price = Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0;
        const wallet = Number(secureLocalStorage.getItem("userwallet")) || 0;

        if (isPremium) {
            if (wallet < price) {
                setToastMsg("Insufficient wallet balance! Please recharge to download PDF.");
                setIsToast(true);
                navigate("/wallet");
                return;
            }
            setShowConfirmModal(true);
        } else {
            proceedDownloadPdf();
        }
    };

    const proceedDownloadPdf = async () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const currentKundliId = savedKundliId || KundliData?.id || KundliData?.Kundli_id || "";
        const isPremium = secureLocalStorage.getItem("kundli_pdf_status") === "1" || secureLocalStorage.getItem("kundli_pdf_status") === 1;
        const price = Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0;
        const wallet = Number(secureLocalStorage.getItem("userwallet")) || 0;

        setDownloadingPdf(true);
        try {
            const requestData = {
                id: Userid,
                Kundli_id: String(currentKundliId),
                wblanguage: pdfLanguage
            };

            const response = await axios({
                url: `${BaseUrl}user/download-kundli-pdf`,
                method: 'POST',
                data: requestData,
                responseType: 'blob',
            });

            if (isPremium) {
                const newBalance = wallet - price;
                secureLocalStorage.setItem("userwallet", newBalance);
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${userdata?.data1?.full_name || KundliData?.firstName || 'Kundli'}_Janam_Patri.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            setToastMsg("PDF report downloaded successfully!");
            setIsToast(true);
        } catch (error) {
            console.error("PDF download error:", error);
            if (error.response && error.response.data instanceof Blob) {
                const text = await error.response.data.text();
                try {
                    const parsedErr = JSON.parse(text);
                    setToastMsg(parsedErr.message || "Failed to download PDF.");
                } catch (e) {
                    setToastMsg("Failed to download PDF. Please try again.");
                }
            } else {
                setToastMsg("Failed to download PDF. Please try again.");
            }
            setIsToast(true);
        } finally {
            setDownloadingPdf(false);
        }
    };

    useEffect(() => {
        if (!Location.state) {
            setToastMsg("Please enter Kundali details first!");
            setIsToast(true);
            navigate("/freekundli");
            return;
        }
        handleFetchData(isstep);
    }, []);

    useEffect(() => {
        const activeEl = document.getElementById(`tab-${isstep}`);
        if (activeEl) {
            activeEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [isstep]);

    const handleFetchData = async (index) => {

        if (HomeRef.current || !KundliData) return;

        HomeRef.current = true;
        const Userid = secureLocalStorage.getItem("Userid");
        let ApiData;
        if (Userid) {
            ApiData = {
                id: Userid,
                Kundli_id: KundliData.id,
                firstName: "",
                lastName: "",
                dateOfBirth: "",
                birthTime: "",
                wb_place: "",
                wb_latitude: "",
                wb_longitude: "",
                wb_timezone_text: "",
                wb_timezone: "",
                wbgender: "",
                chartType: "",
                wblanguage: "",
                section: KundliTypeApiList[index],
                status_platform: 2
            }
        } else {
            ApiData = {
                ...KundliData,
                Kundli_id: "0",
                section: KundliTypeApiList[index],
                status_platform: 2
            }
        }


        const Response = await HandleCallApi("Post", "user/kundli-data", ApiData);
        if (Response && Response.data) {
            if (Response.data.Result === false) {
                setToastMsg(Response.data.message || "Sorry This Plan is currntly closed");
                setIsToast(true);
                navigate("/freekundli");
                return;
            }
            if (Response.data.KundliID) {
                setSavedKundliId(Response.data.KundliID);
            }
            setUserData(Response.data?.resData);
            setIsStep(index);
            setDetailsStep(index + 1);
            setShowList(false);
        } else {
            setToastMsg("Could not fetch Kundali details. Please try again.");
            setIsToast(true);
            navigate("/freekundli");
            return;
        }
        setApiLoading("");
        setLoading(false);
    }

    const handleTypeOfdetail = (count, title) => {
        HomeRef.current = false;
        setApiLoading(title);
        handleFetchData(count);
    }

    const handlecCapitalizeWords = (word = "") => word.toLowerCase().split(" ").map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(",");

    return (
        <div className="kundli_detail">

            {!loading && <div className="width_container">

                <div className='hidden max-_768_:block'>
                    <div className="flex items-center justify-center">
                        <div className="w-full flex items-center border px-[20px] py-[15px] rounded-[15px] bg-white">
                            <button disabled={isstep === 0 || apiloading} onClick={() => handleTypeOfdetail(isstep - 1, "Type")} className="bg-[--bgcolor] p-[8px] rounded-full">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="white" />
                                </svg>
                            </button>
                            <div className="w-full">
                                <h1 onClick={() => apiloading !== "Type" && setShowList(true)} className={`text-center font-medium text-[17px] ${apiloading !== "Type" ? "cursor-pointer" : "cursor-auto"}`}>
                                    {apiloading === "Type"
                                        ? <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                                        : t(kundliTypeList[isstep])}
                                </h1>
                            </div>
                            <button disabled={isstep === (kundliTypeList.length - 1) || apiloading} onClick={() => handleTypeOfdetail(isstep + 1, "Type")} className="bg-[--bgcolor] p-[8px] rounded-full">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="relative w-full flex items-center group mt-4">
                    <button 
                        onClick={() => {
                            const container = document.getElementById('category-container');
                            if (container) container.scrollBy({ left: -200, behavior: 'smooth' });
                        }}
                        className="absolute left-[-15px] z-10 bg-white hover:bg-orange-50 border border-orange-100 shadow-md hover:shadow-lg rounded-full p-2 transition-all duration-300 hover:scale-105 active:scale-95 hidden _768_:flex items-center justify-center text-orange-500 hover:text-orange-600"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 19L8 12L15 5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>

                    <div id="category-container" className="category w-full">
                        {kundliTypeList.map((item, index) => {
                            const IsSelected = index === isstep;
                            return <div key={index} id={`tab-${index}`} onClick={() => handleTypeOfdetail(index, index)} className={`swiper-slide ${IsSelected ? "select" : ""}`}>
                                {apiloading === index
                                    ? <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                                    : t(item)}
                            </div>
                        })}
                    </div>

                    <button 
                        onClick={() => {
                            const container = document.getElementById('category-container');
                            if (container) container.scrollBy({ left: 200, behavior: 'smooth' });
                        }}
                        className="absolute right-[-15px] z-10 bg-white hover:bg-orange-50 border border-orange-100 shadow-md hover:shadow-lg rounded-full p-2 transition-all duration-300 hover:scale-105 active:scale-95 hidden _768_:flex items-center justify-center text-orange-500 hover:text-orange-600"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                <div className="w-full mt-0 mb-8">

                    {detailsstep === 1 && <div className="flex flex-col items-center justify-center">
                        <ImageLoad url={KundliImg} alt={"Kundli img"} CustomeStyle={"w-[300px] hover:scale-105 transition-transform duration-500"} />

                        <div className="text-center mt-6">
                            <h1 className="font-bold text-[24px] text-gray-900 mb-2">{userdata?.data1?.full_name}</h1>
                            <span className="text-sm text-gray-500 font-semibold bg-orange-50 px-4 py-1.5 rounded-full border border-orange-100/50">
                                {userdata?.data1?.year}-{userdata?.data1?.month}-{userdata?.data1?.day}
                            </span>
                            <p className="text-gray-600 mt-3 font-medium flex items-center justify-center gap-1.5">
                                <svg className="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                {userdata?.data1?.place}
                            </p>

                            <div className="mt-6 flex flex-col items-center justify-center gap-2">
                                <div className="flex items-center gap-2 mb-2 bg-orange-50/50 px-4 py-1.5 rounded-full border border-orange-100/30">
                                    <label className="text-xs font-semibold text-gray-700">{t("Select PDF Language:")}</label>
                                    <select
                                        value={pdfLanguage}
                                        onChange={(e) => setPdfLanguage(e.target.value)}
                                        className="h-[30px] border border-gray-300 rounded-full px-2 text-[12px] text-gray-700 outline-none cursor-pointer bg-white hover:border-gray-400 transition-all focus:ring-1 focus:ring-orange-500"
                                    >
                                        <option value="en">{t("English")}</option>
                                        <option value="hi">{t("Hindi")}</option>
                                        <option value="bn">{t("Bengali")}</option>
                                        <option value="ma">{t("Marathi")}</option>
                                        <option value="tm">{t("Tamil")}</option>
                                        <option value="tl">{t("Telugu")}</option>
                                        <option value="ml">{t("Malayalam")}</option>
                                        <option value="kn">{t("Kannada")}</option>
                                    </select>
                                </div>
                                <button
                                    onClick={handleDownloadPdf}
                                    disabled={downloadingPdf}
                                    className="px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold rounded-full shadow-md hover:shadow-lg hover:scale-105 active:scale-95 transition-all duration-300 flex items-center gap-2 disabled:opacity-70 disabled:pointer-events-none"
                                >
                                    {downloadingPdf ? (
                                        <>
                                            <Btn_loader CustomeStyle="bg-white" />
                                            <span>{t("Generating PDF...")}</span>
                                        </>
                                    ) : (
                                        <>
                                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                            </svg>
                                            <span>
                                                {secureLocalStorage.getItem("kundli_pdf_status") === "1" || secureLocalStorage.getItem("kundli_pdf_status") === 1
                                                    ? `${t("Download Premium Janam Patri")} (${formatPrice(Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0)})`
                                                    : t("Download Janam Patri (Free)")}
                                            </span>
                                        </>
                                    )}
                                </button>
                                {(secureLocalStorage.getItem("kundli_pdf_status") === "1" || secureLocalStorage.getItem("kundli_pdf_status") === 1) ? (
                                    <span className="text-xs text-orange-500 font-medium">
                                        *{t("Wallet balance will be deducted to generate PDF")}
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 2 && <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 my-4">
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Basic Details")}
                            </h2>
                            <div className="p-2">
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {[
                                            { label: "Date of Birth", value: `${userdata?.data1?.year}-${userdata?.data1?.month}-${userdata?.data1?.day}` },
                                            { label: "Time of Birth", value: `${userdata?.data1?.hour}:${userdata?.data1?.minute}` },
                                            { label: "Place of Birth", value: userdata?.data1?.place },
                                            { label: "Latitude", value: userdata?.data1?.latitude },
                                            { label: "Longitude", value: userdata?.data1?.longitude },
                                            { label: "Timezone", value: userdata?.data1?.timezone },
                                            { label: "Ayanamsa", value: userdata?.data1?.ayanamsha },
                                            { label: "Sunrise", value: userdata?.data1?.sunrise },
                                            { label: "Sunset", value: userdata?.data1?.sunset }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate max-w-[280px]">{renderVal(item.value)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Ghat Chakra")}
                            </h2>
                            <div className="p-2">
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {[
                                            { label: "Month", value: userdata?.data2?.month },
                                            { label: "Tithi", value: userdata?.data2?.tithi },
                                            { label: "Yoga", value: userdata?.data2?.yoga },
                                            { label: "Karana", value: userdata?.data2?.karana },
                                            { label: "Moon Sign", value: userdata?.data2?.moon_sign },
                                            { label: "Moon Vaar", value: userdata?.data2?.vaar }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate max-w-[280px]">{renderVal(item.value)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Panchange Details")}
                            </h2>
                            <div className="p-2">
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {[
                                            { label: "Tithi", value: userdata?.data1?.tithi },
                                            { label: "Yoga", value: userdata?.data1?.yoga },
                                            { label: "Nakshatra", value: userdata?.data1?.full_name },
                                            { label: "Karana", value: userdata?.data1?.karana }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate max-w-[280px]">{renderVal(item.value)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Astrological Details")}
                            </h2>
                            <div className="p-2">
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {[
                                            { label: "Varna", value: userdata?.data1?.varna },
                                            { label: "Vashya", value: userdata?.data1?.vashya },
                                            { label: "Yoni", value: userdata?.data1?.yoni },
                                            { label: "Gana", value: userdata?.data1?.gana },
                                            { label: "Nadi", value: userdata?.data1?.nadi },
                                            { label: "Sun Sign", value: userdata?.data1?.sunsign },
                                            { label: "Moon Sign", value: userdata?.data1?.moonsign },
                                            { label: "Nakshatra", value: userdata?.data1?.nakshatra },
                                            { label: "Tatva", value: userdata?.data1?.tatva },
                                            { label: "Name", value: userdata?.data1?.rashi_akshar },
                                            { label: "Paya", value: userdata?.data1?.paya || "Paya" },
                                            { label: "Yanja", value: userdata?.data1?.yunja }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate max-w-[280px]">{renderVal(item.value)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 3 && <div className="w-full flex flex-col xl:flex-row gap-6 my-4 animate_fade_in_card">
                        {/* Planetary Positions Table Card */}
                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Planetary Positions")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[300px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Planets")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Sign No")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(userdata?.data1?.planets || []).map((item, index) => (
                                            <tr key={index} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 whitespace-nowrap flex items-center gap-2">
                                                    {item.image && <ImageLoad url={item.image} CustomeStyle="w-6 h-6 rounded-full object-cover border border-orange-200" alt={item.name} />}
                                                    {t(item.name)}
                                                </td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(item.sign)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{item.sign_no}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Planet Cards Grid */}
                        <div className="flex-[1.5] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                            {(userdata?.data1?.planets || []).map((item, index) => (
                                <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col justify-between">
                                    <div className="flex items-center gap-3 p-4">
                                        <div className="w-12 h-12 rounded-full border-2 border-orange-100 p-0.5 flex-shrink-0">
                                            <ImageLoad url={item.image} CustomeStyle={"w-full h-full rounded-full object-cover"} alt={`${item.name} Image`} />
                                        </div>
                                        <div className="overflow-hidden leading-snug">
                                            <h3 className="font-bold text-[16px] text-gray-800 truncate">{t(item.name)}</h3>
                                            <p className="text-[13px] text-gray-500 truncate" title={item.nakshatra}>{t(item.nakshatra)}</p>
                                        </div>
                                    </div>
                                    <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-center py-2.5">
                                        <span className="font-semibold text-[14px] text-white tracking-wide">{t(item.sign)}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>}

                    {detailsstep === 4 && <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 my-4 animate_fade_in_card">
                        {[
                            { title: "LAGNA CHART (BIRTH CHART)", img: userdata?.data1?.base64_image },
                            { title: "MOON CHART", img: userdata?.data2?.base64_image },
                            { title: "NAVMANSHA CHART (D9)", img: userdata?.data3?.base64_image }
                        ].map((chart, idx) => (
                            <div key={idx} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4">
                                <h3 className="font-bold text-[16px] text-gray-800 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t(chart.title)}</h3>
                                <div className="w-full max-w-[320px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                    <ImageLoad url={chart.img} CustomeStyle={"w-full h-full object-contain"} alt={chart.title} />
                                </div>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 5 && <div className="w-full flex flex-col lg:flex-row gap-6 my-4 animate_fade_in_card">
                        <div className="flex-[1.5] border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Chalit House Cusps")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[500px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("House")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Sign (Madhya)")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Bhav Madhya")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Sign (Sandhi)")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Bhav Sandhi")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                                            <tr key={item} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 text-[14px] text-gray-700 text-center font-bold">{item}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{t(userdata?.data1?.chalit_table?.[item]?.mid_point?.sign)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{userdata?.data1?.chalit_table?.[item]?.mid_point?.bhav_madhya}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{t(userdata?.data1?.chalit_table?.[item]?.start_point?.sign)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{userdata?.data1?.chalit_table?.[item]?.start_point?.bhav_madhya}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4">
                            <h3 className="font-bold text-[18px] text-gray-900 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t("Chalit Chart")}</h3>
                            <div className="w-full max-w-[350px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                <ImageLoad url={userdata?.data1?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={"Chalit Chart"} />
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 6 && <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 my-4 animate_fade_in_card">
                        {[
                            { key: "SUN", title: "Sun Chart", desc: "Health, Constitution, Body" },
                            { key: "D2", title: "Hora Chart(D2)", desc: "Finance, Wealth, Prosperity" },
                            { key: "D3", title: "Dreshkan Chart(D3)", desc: "Brothers, Sisters" },
                            { key: "D4", title: "Chathurthamasha Chart(D4)", desc: "Fortunes, Luck of native" },
                            { key: "D7", title: "Saptamansha Chart(D7)", desc: "Impregnation, Birth of the child" },
                            { key: "D10", title: "Dashamansha Chart(D10)", desc: "livelihood, Profession" },
                            { key: "D12", title: "Dwadasha Chart(D12)", desc: "Parents, paternal happiness" },
                            { key: "D16", title: "Shodashamsha Chart(D16)", desc: "Happiness, miseries, conveyance" },
                            { key: "D20", title: "Vishamansha Chart(D20)", desc: "Spiritual progress, worship" },
                            { key: "D24", title: "Chaturvimshamsha(D24)", desc: "Academic achievement, education" },
                            { key: "D27", title: "Bhamsha Chart(D27)", desc: "Physical strength, stamina" },
                            { key: "D30", title: "Trishamansha Chart(D30)", desc: "Evil, Adversities of life" },
                            { key: "D40", title: "Khavedamsha Chart(D40)", desc: "Auspicious & inauspicious effect" },
                            { key: "D45", title: "Akshvedansha Chart(D45)", desc: "Character and couduct of the native" },
                            { key: "D60", title: "Shashtymsah Chart(D60)", desc: "Shows general happiness" }
                        ].map((chart, idx) => (
                            <div key={idx} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4">
                                <h3 className="font-bold text-[16px] text-gray-800 text-center border-b border-orange-100 pb-2 w-full">{t(chart.title)}</h3>
                                <div className="w-full max-w-[320px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 my-3 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                    <ImageLoad url={userdata?.[chart.key]?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={chart.title} />
                                </div>
                                <span className="text-[13px] text-gray-500 text-center font-medium mt-1">{t(chart.desc)}</span>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 7 && <FriendshipTable userdata={userdata} handlecCapitalizeWords={handlecCapitalizeWords} />}

                    {detailsstep === 8 && <div className="w-full grid grid-cols-1 xl:grid-cols-2 gap-6 my-4 animate_fade_in_card">
                        {/* Table 1: Planets Basic Signs */}
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Planets & Signs")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[450px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Planets")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Degrees")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign Lord")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("House")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(userdata?.data1?.planets || []).map((item2, index2) => (
                                            <tr key={index2} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">{t(item2.name)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(item2.sign)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{item2.full_degree}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item2.rashi_lord))}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{item2.house}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Table 2: Planets Nakshatra Lords */}
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Nakshatra & Sub Lords")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[450px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Planets")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra Lord")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sub Lord")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sub Sub Lord")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(userdata?.data1?.planets || []).map((item2, index2) => (
                                            <tr key={index2} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">{t(item2.name)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(item2.nakshatra)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item2.nakshatra_lord))}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item2.sub_lord))}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item2.sub_sub_lord))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 9 && <div className="w-full flex flex-col lg:flex-row gap-6 my-4 animate_fade_in_card">
                        <div className="flex-[1.5] border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("KP House Cusps")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[700px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("House")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Degrees")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign Lord")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra Lord")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sub Lord")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sub Sub Lord")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                                            <tr key={item} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 text-[14px] text-gray-700 text-center font-bold">{item}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(userdata?.data1?.table_data?.[item]?.house_cusp?.sign || "")}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{userdata?.data1?.table_data?.[item]?.house_cusp?.degree || ""}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(userdata?.data1?.table_data?.[item]?.rashi_lord || ""))}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(userdata?.data1?.table_data?.[item]?.nakshatra || "")}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(userdata?.data1?.table_data?.[item]?.nakshatra_lord || ""))}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(userdata?.data1?.table_data?.[item]?.sub_lord || ""))}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(userdata?.data1?.table_data?.[item]?.sub_sub_lord || ""))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4">
                            <h3 className="font-bold text-[18px] text-gray-900 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t("KP Chart")}</h3>
                            <div className="w-full max-w-[350px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                <ImageLoad url={userdata?.data1?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={"KP Chart"} />
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 10 && <div className="w-full flex flex-col gap-6 my-4 animate_fade_in_card">
                        <div className="flex flex-col md:flex-row gap-6 justify-center items-stretch">
                            {/* Left Side: Avatar Card */}
                            <div className="flex-1 max-w-sm border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 p-6 flex flex-col items-center justify-center">
                                <div className="w-48 h-48 rounded-full border-4 border-orange-100 p-1 overflow-hidden shadow-inner bg-orange-50/10">
                                    <ImageLoad url={userdata?.data1?.image} CustomeStyle={"w-full h-full rounded-full object-cover"} alt={"Ascendant Sign"} />
                                </div>
                                <h3 className="font-bold text-[20px] text-gray-800 mt-4 text-center">{t(userdata?.data1?.ascendant || "Ascendant")}</h3>
                            </div>

                            {/* Right Side: Quick Info Table Card */}
                            <div className="flex-[1.5] border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {t("Ascendant Profile")}
                                </h2>
                                <div className="p-2">
                                    <table className="w-full text-left border-collapse">
                                        <tbody>
                                            {[
                                                { label: "Lord", value: userdata?.data1?.planetary_lord },
                                                { label: "Symbol", value: userdata?.data1?.symble },
                                                { label: "Characteristics", value: userdata?.data1?.characteristics },
                                                { label: "Day of Fast", value: userdata?.data1?.day_of_fast },
                                                { label: "Lucky Gems", value: userdata?.data1?.lucky_stone?.join(", ") }
                                            ].map((item, idx) => (
                                                <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{renderVal(item.value) || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Detailed Reports Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                            {[
                                { title: "Personality", content: userdata?.data1?.analysis?.personality },
                                { title: "Career", content: userdata?.data1?.analysis?.career },
                                { title: "Health", content: userdata?.data1?.analysis?.health },
                                { title: "Finance", content: userdata?.data1?.analysis?.finance },
                                { title: "Relationships", content: userdata?.data1?.analysis?.relationships }
                            ].map((report, idx) => (
                                <div key={idx} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col">
                                    <h3 className="px-5 py-4 font-bold text-[16px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                        <div className="w-1.5 h-5 bg-orange-500 rounded-full"></div>
                                        {t(report.title)}
                                    </h3>
                                    <div className="p-5 flex-1">
                                        <p className="text-[14px] text-gray-600 leading-relaxed whitespace-pre-line">{renderVal(report.content)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>}

                    {detailsstep === 11 && <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 my-4 animate_fade_in_card">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                            <div key={item} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4">
                                <h3 className="font-bold text-[16px] text-gray-800 text-center border-b border-orange-100 pb-2 w-full">
                                    {t("BHAVA KUNDLI")} {item}
                                </h3>
                                <div className="w-full max-w-[320px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 my-3 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                    <ImageLoad url={userdata?.[item]?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={`Bhava Kundli ${item}`} />
                                </div>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 12 && <div className="w-full flex justify-center my-4 animate_fade_in_card">
                        <div className="w-full max-w-3xl">
                            {Object.entries(userdata?.data1?.maha_dasha || {}).map(([key, data], index) => (
                                <Vimshottari_Dasha
                                    key={index}
                                    index={index}
                                    item={key}
                                    data={data}
                                />
                            ))}
                        </div>
                    </div>}

                    {detailsstep === 13 && <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 my-4 animate_fade_in_card">
                        {(userdata?.data1?.maha_dasha || []).map((item, index) => (
                            <div key={index} className="border border-orange-100/50 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <div className="bg-gradient-to-r from-orange-500 to-amber-500 px-5 py-4 text-white flex justify-between items-center">
                                    <h3 className="font-bold text-[16px] tracking-wide">{t(item.dasha)}</h3>
                                    <span className="text-[12px] bg-white/20 px-3 py-1 rounded-full border border-white/15">
                                        {item.start_date} - {item.end_date}
                                    </span>
                                </div>
                                <div className="p-5">
                                    <div className="relative border-l-2 border-orange-100 ml-2 pl-5 space-y-3">
                                        {Object.entries(item.antar_dasha || {}).map(([name, date], subIdx) => (
                                            <div key={subIdx} className="relative flex items-center justify-between text-[14px]">
                                                {/* Timeline bullet */}
                                                <div className="absolute -left-[27px] top-1.5 w-3 h-3 rounded-full border-2 border-white bg-orange-400 shadow-sm"></div>
                                                <span className="font-semibold text-gray-700">{t(name)}</span>
                                                <span className="text-gray-500 font-medium text-[13px]">{date}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 14 && <div className="w-full max-w-2xl mx-auto my-4 animate_fade_in_card">
                        <div className="border border-orange-100/50 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Remedies Of Sadhesati")}
                            </h2>
                            <div className="p-4 space-y-3">
                                {(userdata?.data1?.remedies || []).map((item, index) => (
                                    <div key={index} className="flex gap-4 p-4 rounded-xl bg-orange-50/30 border border-orange-100/40 hover:bg-orange-50/50 transition-colors">
                                        <div className="w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold flex items-center justify-center flex-shrink-0">
                                            {index + 1}
                                        </div>
                                        <p className="text-[14px] text-gray-600 leading-relaxed font-medium pt-0.5">{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 15 && <div className="w-full border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden my-4 animate_fade_in_card">
                        <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                            <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                            {t("Sadhesati Life Analysis")}
                        </h2>
                        <div className="p-4 overflow-x-auto">
                            <table className="w-full text-left border-collapse min-w-[600px]">
                                <thead>
                                    <tr className="border-b border-gray-200">
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Moon Sign")}</th>
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Saturn Sign")}</th>
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Is Saturn Retro?")}</th>
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Phase")}</th>
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Date")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(userdata?.data1?.sadhesati_life_analysis || []).map((item2, index2) => (
                                        <tr key={index2} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                            <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{t(userdata?.data1?.moon_sign)}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{t(item2.sign_name)}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{item2.is_retro ? t("Yes") : t("No")}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{t(item2.phase)}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{item2.date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {detailsstep === 16 && <div className="w-full max-w-md mx-auto my-4 animate_fade_in_card">
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Kalsarpa Dosha")}
                            </h2>
                            <div className="p-2">
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {[
                                            { label: "Name", value: userdata?.data1?.name },
                                            { label: "Intensity", value: userdata?.data1?.intensity },
                                            { label: "Direction", value: userdata?.data1?.direction }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{renderVal(item.value) || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 17 && <div className="w-full max-w-md mx-auto my-4 animate_fade_in_card">
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Manglik Analysis")}
                            </h2>
                            <div className="p-2">
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {[
                                            { label: "Strength", value: userdata?.data1?.strength },
                                            { label: "Percentage", value: userdata?.data1?.percentage }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{renderVal(item.value) || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 18 && <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 my-4 animate_fade_in_card">
                        {(userdata?.data2?.planets || []).map((item, index) => (
                            <div key={index} className="border border-orange-100/50 bg-white rounded-2xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col justify-between">
                                <div className="py-6 bg-gradient-to-r from-orange-50/50 to-amber-50/30 flex justify-center border-b border-orange-50">
                                    <div className="w-24 h-24 rounded-full border-4 border-white shadow bg-white p-0.5 overflow-hidden">
                                        <ImageLoad url={item.image} CustomeStyle={"w-full h-full rounded-full object-cover"} alt={`${item.name} img`} />
                                    </div>
                                </div>
                                <div className="p-2 flex-1">
                                    <table className="w-full text-left border-collapse">
                                        <tbody>
                                            {[
                                                { title: "Zodiac Sign", value: item.sign },
                                                { title: "Planet Degree", value: item.full_degree },
                                                { title: "Nakshatra", value: item.nakshatra },
                                                { title: "Lord Of", value: item.lord_of },
                                                { title: "House", value: item.house },
                                                { title: "Combust/Awake", value: item.is_combusted }
                                            ].map((field, idx) => (
                                                <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[13px] text-gray-700 w-1/3 whitespace-nowrap">{t(field.title)}</td>
                                                    <td className="px-4 py-3 text-[13px] text-gray-600">{renderVal(field.value) || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 19 && <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 my-4 animate_fade_in_card">
                        {[
                            { title: "Lucky Stone", data: userdata?.data1?.lucky_stone },
                            { title: "Life Stone", data: userdata?.data1?.life_stone }
                        ].map((stone, index) => (
                            <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-white bg-gradient-to-r from-orange-500 to-amber-500 flex items-center gap-2">
                                    {t(stone.title)}
                                </h2>
                                <div className="p-2">
                                    <table className="w-full text-left border-collapse">
                                        <tbody>
                                            {[
                                                { label: "Finger", value: stone.data?.finger_to_wear },
                                                { label: "Day", value: stone.data?.day_to_wear },
                                                { label: "Time to Wear", value: stone.data?.time_to_wear },
                                                { label: "Mantra", value: stone.data?.mantra }
                                            ].map((item, idx) => (
                                                <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 w-1/3 whitespace-nowrap">{t(item.label)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600 leading-relaxed">{renderVal(item.value) || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 20 && <div className="w-full flex flex-col xl:flex-row gap-6 my-4 animate_fade_in_card">
                        <div className="flex-[2] flex flex-col gap-6">
                            {/* Table 1: Upagraha Longitude */}
                            <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {t("Upagraha Longitude")}
                                </h2>
                                <div className="p-4 overflow-x-auto">
                                    <table className="w-full text-left border-collapse min-w-[500px]">
                                        <thead>
                                            <tr className="border-b border-gray-200">
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Upagraha")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Longitude")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Rashi")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Pada")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(userdata?.data1?.planets || []).map((item, index) => (
                                                <tr key={index} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">{t(item.name)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{item.longitude}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(item.sign_name)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(item.nakshatra)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{item.house}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Table 2: Upagraha Nakshatra Sub Lord */}
                            <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {t("Upagraha Nakshatra / Sub Lord")}
                                </h2>
                                <div className="p-4 overflow-x-auto">
                                    <table className="w-full text-left border-collapse min-w-[500px]">
                                        <thead>
                                            <tr className="border-b border-gray-200">
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Upagraha")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra Lord")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sub Lord")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sub Sub Lord")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(userdata?.data1?.planets || []).map((item, index) => (
                                                <tr key={index} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">{t(item.name)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(item.nakshatra)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item.nakshatra_lord))}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item.sub_lord))}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(renderVal(item.sub_sub_lord))}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Right Side: Upagraha Chart */}
                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4 h-fit">
                            <h3 className="font-bold text-[18px] text-gray-900 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t("Upagraha Chart")}</h3>
                            <div className="w-full max-w-[320px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                <ImageLoad url={userdata?.data2?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={"Upagraha Chart"} />
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 21 && <div className="w-full flex flex-col xl:flex-row gap-6 my-4 animate_fade_in_card">
                        <div className="flex-[2] flex flex-col gap-6">
                            {/* Table 1: Jamini Planets */}
                            <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {t("Jaimini Planets")}
                                </h2>
                                <div className="p-4 overflow-x-auto">
                                    <table className="w-full text-left border-collapse min-w-[300px]">
                                        <thead>
                                            <tr className="border-b border-gray-200">
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Planets")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Degrees")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(userdata?.data1 || []).map((item, index) => (
                                                <tr key={index} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">{t(item.name)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(item.sign)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{item.full_degree}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Table 2: Jamini Padas */}
                            <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {t("Jaimini Padas")}
                                </h2>
                                <div className="p-4 overflow-x-auto">
                                    <table className="w-full text-left border-collapse min-w-[400px]">
                                        <thead>
                                            <tr className="border-b border-gray-200">
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Code")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Pada")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("House")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(userdata?.data2?.padas_table || []).map((item, index) => (
                                                <tr key={index} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">{item.code}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{item.pada}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{t(item.sign)}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{item.house}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Right Side: Jamini Karakara Chart */}
                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4 h-fit">
                            <h3 className="font-bold text-[18px] text-gray-900 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t("Jaimini Karaka Chart")}</h3>
                            <div className="w-full max-w-[320px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                <ImageLoad url={userdata?.data3?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={"Jaimini Chart"} />
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 22 && <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 my-4 animate_fade_in_card">
                        {(userdata?.data1?.maha_dasha || []).map((item, index) => (
                            <div key={index} className="border border-orange-100/50 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <div className="bg-gradient-to-r from-orange-500 to-amber-500 px-5 py-4 text-white flex justify-between items-center">
                                    <h3 className="font-bold text-[16px] tracking-wide">{t(item.dasha)}</h3>
                                    <span className="text-[12px] bg-white/20 px-3 py-1 rounded-full border border-white/15">
                                        {item.start_date} - {item.end_date}
                                    </span>
                                </div>
                                <div className="p-5">
                                    <div className="relative border-l-2 border-orange-100 ml-2 pl-5 space-y-3">
                                        {(item.antar_dasha || []).map(({ dasha, start_date }, subIdx) => (
                                            <div key={subIdx} className="relative flex items-center justify-between text-[14px]">
                                                {/* Timeline bullet */}
                                                <div className="absolute -left-[27px] top-1.5 w-3 h-3 rounded-full border-2 border-white bg-orange-400 shadow-sm"></div>
                                                <span className="font-semibold text-gray-700">{t(dasha)}</span>
                                                <span className="text-gray-500 font-medium text-[13px]">{start_date}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>}

                    {detailsstep === 23 && <div className="w-full border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden my-4 animate_fade_in_card">
                        <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                            <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                            {t("Shadbala Analysis")}
                        </h2>
                        <div className="p-4 overflow-x-auto">
                            <table className="w-full text-left border-collapse min-w-[800px]">
                                <thead>
                                    <tr className="border-b border-gray-200">
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 sticky left-0 bg-white z-10">{t("Bala Type")}</th>
                                        {["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn"].map((planet, idx) => (
                                            <th key={idx} className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t(planet)}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {[
                                        { label: "Uchcha Bala", path: (p) => userdata?.data1?.sthana_bala?.uccha_bala?.[p] },
                                        { label: "Saptavarga Bala", path: (p) => userdata?.data1?.sthana_bala?.saptavarghiya_bala?.[p] },
                                        { label: "Yugmayugma Bhamsha Bala", path: (p) => userdata?.data1?.sthana_bala?.yugmayugma_bhamsha_bala?.[p] },
                                        { label: "Kendradi Bala", path: (p) => userdata?.data1?.sthana_bala?.kendradi_bala?.[p] },
                                        { label: "Drekkana Bala", path: (p) => userdata?.data1?.sthana_bala?.drekkana_bala?.[p] },
                                        { label: "Total Sthana Bala", path: (p) => userdata?.data1?.sthana_bala?.total?.[p], isBold: true },
                                        { label: "Total Dig Bala", path: (p) => userdata?.data1?.digbala?.[p], isBold: true },
                                        { label: "Nattunnata Bala", path: (p) => userdata?.data1?.kaal_bala?.nattunnata_bala?.[p] },
                                        { label: "Paksha Bala", path: (p) => userdata?.data1?.kaal_bala?.paksha_bala?.[p] },
                                        { label: "Tribhaga Bala", path: (p) => userdata?.data1?.kaal_bala?.tribhaga_bala?.[p] },
                                        { label: "Varshadhipati", path: (p) => userdata?.data1?.kaal_bala?.varshadhipati?.[p] },
                                        { label: "Maasadipati", path: (p) => userdata?.data1?.kaal_bala?.maasadipati?.[p] },
                                        { label: "Vaaradhipati", path: (p) => userdata?.data1?.kaal_bala?.vaaradhipati?.[p] },
                                        { label: "Horadhipati", path: (p) => userdata?.data1?.kaal_bala?.horadhipati?.[p] },
                                        { label: "Ayana Bala", path: (p) => userdata?.data1?.kaal_bala?.ayana_bala?.[p] },
                                        { label: "Yuddha Bala", path: (p) => userdata?.data1?.kaal_bala?.yuddha_bala?.[p] },
                                        { label: "Total Kaal Bala", path: (p) => userdata?.data1?.kaal_bala?.total?.[p], isBold: true },
                                        { label: "Naisargika Bala", path: (p) => userdata?.data1?.naisargika_bala?.[p] },
                                        { label: "Chestha Bala", path: (p) => userdata?.data1?.chestha_bala?.[p] },
                                        { label: "Drik Bala", path: (p) => userdata?.data1?.drik_bala?.[p] },
                                        { label: "Total Shadbala", path: (p) => userdata?.data1?.total_shadbala?.[p], isBold: true },
                                        { label: "Shadbala In Rupa", path: (p) => userdata?.data1?.shadbala_in_rupa?.[p] },
                                        { label: "Min Require", path: (p) => userdata?.data1?.min_require?.[p] },
                                        { label: "Ratio", path: (p) => userdata?.data1?.ratio?.[p] },
                                        { label: "Rank", path: (p) => userdata?.data1?.rank?.[p], isBold: true }
                                    ].map((row, rowIdx) => (
                                        <tr key={rowIdx} className={`border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors ${row.isBold ? "bg-orange-50/30 font-semibold" : ""}`}>
                                            <td className="px-4 py-3 text-[14px] text-gray-700 font-medium sticky left-0 bg-white shadow-[2px_0_5px_rgba(0,0,0,0.02)]">{t(row.label)}</td>
                                            {["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn"].map((planet, colIdx) => (
                                                <td key={colIdx} className="px-4 py-3 text-[14px] text-gray-600 text-center">{renderVal(row.path(planet))}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {detailsstep === 24 && <div className="w-full flex justify-center my-4 animate_fade_in_card">
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-6 max-w-xl w-full">
                            <h3 className="font-bold text-[18px] text-gray-900 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t("Sudarshana Chakra")}</h3>
                            <div className="w-full aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-4 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                <ImageLoad url={userdata?.data1?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={"Sudarshana Chakra"} />
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 25 && <div className="w-full flex flex-col gap-4 my-4 animate_fade_in_card">
                        <div className="flex flex-wrap items-center justify-center gap-3 mb-6 bg-orange-50/50 p-2 rounded-2xl border border-orange-100/50 w-fit mx-auto">
                            {["Ashtakvarga", "Sarvashtakava", "Prasthara Chakra"].map((item, index) => {
                                const IsSelected = selecttype === index;
                                return (
                                    <button 
                                        key={index} 
                                        onClick={() => setSelectType(index)} 
                                        className={`px-6 py-2.5 rounded-xl text-[14px] font-bold transition-all duration-300 ${
                                            IsSelected 
                                                ? "bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-md shadow-orange-500/20" 
                                                : "bg-white text-gray-600 hover:text-orange-500 border border-gray-100 hover:border-orange-100"
                                        }`}
                                    >
                                        {t(item)}
                                    </button>
                                );
                            })}
                        </div>

                        {selecttype === 0 && <div className="space-y-6 animate_fade_in_card">
                            {Object.entries(userdata?.data1?.table || {}).map(([list, value], index) => (
                                <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                    <h3 className="px-5 py-4 font-bold text-[16px] text-gray-900 border-b border-gray-100 bg-orange-50/10">
                                        {t("Ashtakvarga")} : <span className="text-orange-600 font-extrabold">{t(list)}</span>
                                    </h3>
                                    <div className="p-4 overflow-x-auto">
                                        <table className="w-full text-left border-collapse min-w-[700px]">
                                            <thead>
                                                <tr className="border-b border-gray-200">
                                                    <th className="px-4 py-3 text-[14px] font-bold text-gray-800 sticky left-0 bg-white">{t("Planets")}</th>
                                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                                                        <th key={num} className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{num}</th>
                                                    ))}
                                                    <th className="px-4 py-3 text-[14px] font-bold text-orange-600 text-center">{t("Points")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {["Saturn", "Jupiter", "Mars", "Sun", "Venus", "Mercury", "Moon", "Ascendant", "Total"].map((title, pIdx) => {
                                                    const isTotal = title === "Total";
                                                    return (
                                                        <tr key={pIdx} className={`border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors ${isTotal ? "bg-orange-50/30 font-semibold" : ""}`}>
                                                            <td className="px-4 py-3 text-[14px] text-gray-700 font-medium sticky left-0 bg-white">{t(title)}</td>
                                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                                                                <td key={num} className="px-4 py-3 text-[14px] text-gray-600 text-center">{renderVal(value?.[title]?.[num])}</td>
                                                            ))}
                                                            <td className="px-4 py-3 text-[14px] text-orange-600 text-center font-bold">{renderVal(value?.[title]?.points)}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}
                        </div>}

                        {selecttype === 1 && <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 my-4 animate_fade_in_card">
                            {Object.entries(userdata?.data1?.chart || {}).map(([item, value], index) => (
                                <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col items-center p-4">
                                    <h3 className="font-bold text-[16px] text-gray-800 mb-4 text-center border-b border-orange-100 pb-2 w-full">{t(item)}</h3>
                                    <div className="w-full max-w-[320px] aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300">
                                        <ImageLoad url={value.base64_image} CustomeStyle={"w-full h-full object-contain"} alt={"Chart image"} />
                                    </div>
                                </div>
                            ))}
                        </div>}

                        {selecttype === 2 && <div className="space-y-6 animate_fade_in_card">
                            {[{ title: "Trinona Reduction", key: "trinona_reduction" },
                            { title: "Ekadhipatya Reductions", key: "ekadhipatya_reductions" }
                            ].map((item, index) => (
                                <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                    <h3 className="px-5 py-4 font-bold text-[16px] text-gray-900 border-b border-gray-100 bg-orange-50/10">
                                        {t("Prasthara Chakra")} : <span className="text-orange-600 font-extrabold">{t(item.title)}</span>
                                    </h3>
                                    <div className="p-4 overflow-x-auto">
                                        <table className="w-full text-left border-collapse min-w-[600px]">
                                            <thead>
                                                <tr className="border-b border-gray-200">
                                                    <th className="px-4 py-3 text-[14px] font-bold text-gray-800 sticky left-0 bg-white">{t("Planets")}</th>
                                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                                                        <th key={num} className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{num}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.entries(userdata?.data10?.[item.key] || {}).map(([title, value], pIdx) => (
                                                    <tr key={pIdx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                        <td className="px-4 py-3 text-[14px] text-gray-700 font-medium sticky left-0 bg-white">{t(title)}</td>
                                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
                                                            <td key={num} className="px-4 py-3 text-[14px] text-gray-600 text-center">{renderVal(value?.[num])}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}

                            <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h3 className="px-5 py-4 font-bold text-[16px] text-gray-900 border-b border-gray-100 bg-orange-50/10">
                                    {t("Prasthara Chakra")} : <span className="text-orange-600 font-extrabold">{t("Shodaya Pinda")}</span>
                                </h3>
                                <div className="p-4 overflow-x-auto">
                                    <table className="w-full text-left border-collapse min-w-[600px]">
                                        <thead>
                                            <tr className="border-b border-gray-200">
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800 sticky left-0 bg-white">{t("Pinda Type")}</th>
                                                {["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn"].map((planet) => (
                                                    <th key={planet} className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t(planet)}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {["Rashi Pinda", "Graha Pinda", "Total"].map((title, pIdx) => {
                                                const isTotal = title === "Total";
                                                return (
                                                    <tr key={pIdx} className={`border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors ${isTotal ? "bg-orange-50/30 font-semibold" : ""}`}>
                                                        <td className="px-4 py-3 text-[14px] text-gray-700 font-medium sticky left-0 bg-white">{t(title)}</td>
                                                        {["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn"].map((planet) => (
                                                            <td key={planet} className="px-4 py-3 text-[14px] text-gray-600 text-center">{renderVal(userdata?.data10?.shodaya_pinda?.[title]?.[planet])}</td>
                                                        ))}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>}
                    </div>}

                    {detailsstep === 26 && <div className="w-full flex flex-col gap-6 my-4 animate_fade_in_card">
                        {Object.entries(userdata?.data1 || {}).map(([title, key], index) => (
                            <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col">
                                <h3 className="px-5 py-4 font-bold text-[16px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-1.5 h-5 bg-orange-500 rounded-full"></div>
                                    {renderVal(key?.name)}
                                </h3>
                                <div className="p-5 flex-1 space-y-3">
                                    {(key?.content?.detail || []).map((item, itemIdx) => (
                                        <p key={itemIdx} className="text-[14px] text-gray-600 leading-relaxed">{renderVal(item)}</p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>}
                </div>
            </div>}

            {showlist && <div onClick={() => setShowList(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} style={{ width: "360px" }} className="max-h-[60vh] bg-white py-[10px] px-[20px] rounded-[15px] scroll_container">
                    {kundliTypeList.map((item, index) => {
                        const IsSelected = isstep === index
                        return <div onClick={() => handleTypeOfdetail(index, item)} key={index} className={`border mt-[10px] px-[15px] h-[40px] flex items-center rounded-[10px] cursor-pointer ${IsSelected ? "bg-[--bgcolor] border-[--bgcolor] text-white" : "border-gray-200 text-black"}`}>
                            {apiloading == item
                                ? <Btn_loader CustomeStyle={IsSelected ? "bg-white" : "bg-[--bgcolor]"} />
                                : <h1 className="text-[15px] font-medium">{t(item)}</h1>}
                        </div>
                    })}
                </div>
            </div>}

            {/* Custom Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl border border-gray-100 transition-all duration-300">
                        <h3 className="text-xl font-bold text-gray-900 mb-3">{t("Confirm Download")}</h3>
                        <p className="text-gray-600 mb-6">
                            {t("Downloading this premium PDF will deduct")} {formatPrice(Number(secureLocalStorage.getItem("kundli_pdf_price")) || 0)} {t("from your wallet. Do you want to proceed?")}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-semibold text-sm hover:bg-gray-50 active:scale-95 transition-all"
                            >
                                {t("Cancel")}
                            </button>
                            <button
                                onClick={() => {
                                    setShowConfirmModal(false);
                                    proceedDownloadPdf();
                                }}
                                className="px-5 py-2.5 rounded-xl bg-[--bgcolor] hover:bg-opacity-90 text-white font-semibold text-sm shadow-md hover:shadow-lg active:scale-95 transition-all"
                            >
                                {t("OK")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <PageLoading loading={loading} />
        </div >
    )
}

export default Kundali_details;

const Vimshottari_Dasha = ({ item, data, index }) => {
    const { t } = useTranslation();
    const [isshow, setIsShow] = useState(false);

    return (
        <div key={index} className="bg-white border border-orange-100/50 mt-4 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
            <div 
                onClick={() => setIsShow(!isshow)} 
                className="flex items-center justify-between gap-4 cursor-pointer p-4 bg-gradient-to-r from-orange-50/50 to-amber-50/30 hover:from-orange-50 hover:to-amber-50/50 transition-colors"
            >
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-bold text-[14px]">
                        {index + 1}
                    </div>
                    <h3 className="font-bold text-[16px] text-gray-800">
                        {t(item)} <span className="text-[13px] font-normal text-gray-500 ml-2">({`${data?.start_date} - ${data?.end_date}`})</span>
                    </h3>
                </div>
                <svg width="20" height="20" className={`duration-200 ${isshow ? "rotate-[180deg] text-orange-500" : "rotate-0 text-gray-400"}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 15C11.744 15 11.488 14.9021 11.293 14.7071L7.29301 10.7071C6.90201 10.3161 6.90201 9.68401 7.29301 9.29301C7.68401 8.90201 8.31607 8.90201 8.70707 9.29301L12 12.586L15.293 9.29301C15.684 8.90201 16.3161 8.90201 16.7071 9.29301C17.0981 9.68401 17.0981 10.3161 16.7071 10.7071L12.7071 14.7071C12.5121 14.9021 12.256 15 12 15Z" fill="currentColor" />
                </svg>
            </div>

            <AnimatePresence initial={false}>
                {isshow && (
                    <motion.div
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { height: "auto", opacity: 1 },
                            collapsed: { height: 0, opacity: 0 },
                        }}
                        transition={{ duration: 0.3 }}
                        className='p-4 border-t border-orange-100/50 bg-white'
                    >
                        <div className="relative border-l-2 border-orange-100 ml-4 pl-6 space-y-4">
                            {Object.entries(data?.antar_dasha || {}).map(([key2, data2], index2) => (
                                <Pratyantar_dasha key={index2} item={key2} data={data2} index={index2} />
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const Pratyantar_dasha = ({ item, data, index }) => {
    const { t } = useTranslation();
    const [isshow, setIsShow] = useState(false);

    return (
        <div key={index} className="relative">
            {/* Timeline bullet */}
            <div className="absolute -left-[31px] top-1.5 w-4 h-4 rounded-full border-4 border-white bg-orange-400 shadow-sm"></div>
            
            <div 
                onClick={() => setIsShow(!isshow)} 
                className="bg-orange-50/30 hover:bg-orange-50/70 border border-orange-100/50 rounded-xl p-3 cursor-pointer transition-all duration-200 flex items-center justify-between"
            >
                <span className="font-semibold text-[14px] text-gray-700">
                    {t(item)} <span className="text-[12px] font-normal text-gray-500 ml-2">({`${data?.start_time} - ${data?.end_time}`})</span>
                </span>
                <svg width="18" height="18" className={`duration-200 ${isshow ? "rotate-[180deg] text-orange-500" : "rotate-0 text-gray-400"}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 15C11.744 15 11.488 14.9021 11.293 14.7071L7.29301 10.7071C6.90201 10.3161 6.90201 9.68401 7.29301 9.29301C7.68401 8.90201 8.31607 8.90201 8.70707 9.29301L12 12.586L15.293 9.29301C15.684 8.90201 16.3161 8.90201 16.7071 9.29301C17.0981 9.68401 17.0981 10.3161 16.7071 10.7071L12.7071 14.7071C12.5121 14.9021 12.256 15 12 15Z" fill="currentColor" />
                </svg>
            </div>

            <AnimatePresence initial={false}>
                {isshow && (
                    <motion.div
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { height: "auto", opacity: 1 },
                            collapsed: { height: 0, opacity: 0 },
                        }}
                        transition={{ duration: 0.2 }}
                        className='overflow-hidden mt-2 ml-3 pl-3 border-l border-dashed border-orange-200'
                    >
                        <div className="bg-orange-50/20 p-3 rounded-lg text-gray-600 text-[13px] leading-relaxed">
                            {t(item)} ({data.pratyantar_dasha?.[item]?.start_time} - {data.pratyantar_dasha?.[item]?.end_time})
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const FriendshipTable = ({ userdata, handlecCapitalizeWords }) => {
    const { t } = useTranslation();
    return (
        <div className="w-full flex flex-col gap-8 my-4 animate_fade_in_card">
            {Object.entries(userdata?.data1 || {}).map(([name, data], index) => {
                const titleText = handlecCapitalizeWords(name.replaceAll("_", " ")).replaceAll(",", " ");
                const planetList = Object.keys(data || {});
                return (
                    <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                        <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2 bg-orange-50/10">
                            <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                            {t(titleText)}
                        </h2>
                        <div className="p-4 overflow-x-auto">
                            <table className="w-full text-left border-collapse min-w-[600px]">
                                <thead>
                                    <tr className="border-b border-gray-200">
                                        <th className="px-4 py-3 text-[14px] font-bold text-gray-800 sticky left-0 bg-white">{t("Planets")}</th>
                                        {planetList.map((planet) => (
                                            <th key={planet} className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t(planet)}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {planetList.map((planetRow, rIdx) => (
                                        <tr key={rIdx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                            <td className="px-4 py-3 text-[14px] text-gray-700 font-semibold sticky left-0 bg-white">{t(planetRow)}</td>
                                            {planetList.map((planetCol, cIdx) => (
                                                <td key={cIdx} className="px-4 py-3 text-[14px] text-gray-600 text-center">{data?.[planetRow]?.[planetCol]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
